import * as Carousel from './editors/Carousel';
import * as Gallery from './editors/Gallery';
import * as SideBySideTextMedia from './editors/SideBySideTextMedia';
import * as SideBySideText from './editors/SideBySideText';
import * as BuyNow from './editors/BuyNow';
import * as BuyAddons from './editors/BuyAddons';
import * as VideoGuides from './editors/VideoGuides';
import * as Blog from './editors/Blog';
import * as FAQs from './editors/FAQ';
import * as Intro from './editors/Intro';
import * as Properties from './editors/Properties';
import Modal from '../node_modules/modal-js/dist/modal';
import Bind from 'bind.js';

let editorMapping = {
  'carousel': Carousel,
  'gallery': Gallery,
  'side-by-side-text-media': SideBySideTextMedia,
  'side-by-side-text': SideBySideText,
  'buy-now': BuyNow,
  'buy-addons': BuyAddons,
  'blog': Blog,
  'video-guides': VideoGuides,
  'faqs': FAQs,
  'intro': Intro
}

export default class EditorModal {
  constructor(options) {
    if (!options.type ||
        editorMapping[options.type] === undefined ||
        typeof editorMapping[options.type].default !== 'function')
      return console.log("No renderer for ", options.type);

    this.type = options.type;
    this.path = options.path;
    this.flux = options.flux;
    this.data = options.data;

    this.editorMapper = editorMapping[this.type];
    let form = this.editorMapper.default();

    let properties = false, propertiesElement = "";
    if (this.data && this.data.properties) {
      properties = true;
      propertiesElement = Properties.default(this.data.properties);
    }

    let modalTemplate = `
      <div>
        <a href="#" class="properties ${properties ? 'propertiesShow' : 'propertiesHide'}">Properties</a>
        <a href="#" class="resizeModal resize">Bigger</a>
        <a href="#" class="closeModal close">Close</a>
        ${form}
        ${propertiesElement}
      </div>
    `;

    this.modal = new Modal({
      el: modalTemplate,
      containerEl: document.getElementById('modals-container'),
      activeClass: 'modal-active',
      onShow: () => {},
      onHide: () => {},
      onClickOutside: (modal) => {
        modal.hide();
      }
    });

    this.modal.setup();

    if (this.editorMapper.mapping) {
      this.editor = Bind(this.editorMapper.mapping({data: options.data, path: this.path}),
                         this.editorMapper.transform({modal: this.modal, path: this.path,
                                                      updateState: this.updateState.bind(this)}));

      if (properties) {
        this.propertiesEditor = Bind(Properties.mapping({data: options.data.properties}),
                                     Properties.transform({modal: this.modal,
                                                           updateProperties: this.updateProperties.bind(this)}));
      }
    }

    this.setupButtons();
  }

  updateProperties() {
    let originalPath = this.path.slice(0);
    if (originalPath.length > 0) {
      originalPath.splice(1,1);
    }

    this.flux.getActions('sections').updateSectionProperties(originalPath.join(" "),
                                                             Properties.getData(this.data.properties, this.propertiesEditor));

    if (this.editorMapper.onPropertiesOpen !== undefined)
      this.editorMapper.onPropertiesOpen({path: this.path, properties: this.propertiesEditor.properties});
  }

  updateState(save = true) {
    let originalPath = this.path.slice(0);
    if (originalPath.length > 0) {
      originalPath.splice(1,1);
    }
    this.flux.getActions('sections').updateSection(originalPath.join(" "),
                                                   this.editorMapper.getData(this.data, this.editor),
                                                   save);
  }

  setupButtons() {
    let closeButtons = this.modal.el.getElementsByClassName("closeModal");

    for (let i = 0; i < closeButtons.length; i++) {
      closeButtons[i].onclick = (event) => {
        event.preventDefault();
        if (this.editorMapper.onClose !== undefined)
          this.editorMapper.onClose({path: this.path, properties: this.propertiesEditor.properties});

        this.modal.hide();
      };
    }

    let resizeButtons = this.modal.el.getElementsByClassName("resizeModal");

    for (let i = 0; i < resizeButtons.length; i++) {
      resizeButtons[i].onclick = function (event) {
        event.preventDefault();
        this.resizeElement(event.target.innerHTML);

        event.target.innerHTML = (event.target.innerHTML === "Bigger") ? "Smaller"
                                                                       : "Bigger";

        if (event.target.innerHTML === "Smaller") {
          let previous = event.target.previousElementSibling;

          if (previous) {
            previous.className += " extraSpace";
          }
        } else {
          let previous = event.target.previousElementSibling;

          if (previous) {
            previous.className = previous.className.replace("extraSpace", "");
          }
        }
      }.bind(this);
    }

    let propertiesButton = this.modal.el.getElementsByClassName("properties");

    for (let i = 0; i < propertiesButton.length; i++) {
      propertiesButton[i].onclick = function (event) {
        event.preventDefault();

        if (event.target.innerHTML == "Properties") {
          this.modal.el.getElementsByClassName('form')[0].style.display = 'none';
          this.modal.el.getElementsByClassName('propertiesForm')[0].style.display = 'block';
          if (this.editorMapper.onPropertiesOpen !== undefined)
            this.editorMapper.onPropertiesOpen({path: this.path, properties: this.propertiesEditor.properties});
          event.target.innerHTML = "Editor";
        } else {
          this.modal.el.getElementsByClassName('form')[0].style.display = 'flex';
          this.modal.el.getElementsByClassName('propertiesForm')[0].style.display = 'none';
          if (this.editorMapper.onPropertiesClose !== undefined)
            this.editorMapper.onPropertiesClose({path: this.path});
          event.target.innerHTML = "Properties";
        }
      }.bind(this);
    }
  }

  resizeElement(resizeTo) {
    let form = this.modal.el.getElementsByClassName('form')[0];
    let propertiesForm = this.modal.el.getElementsByClassName('propertiesForm')[0];
    let editorFields = this.modal.el.getElementsByClassName('editor-fields')[0];
    let fieldsContainers = this.modal.el.getElementsByClassName('field-item-container');
    let height = (resizeTo === "Bigger") ? 420 : 260;

    this.modal.el.parentNode.style.height = height + "px";

    form.style.height = height - 60 + "px";

    if (propertiesForm) propertiesForm.style.height = height - 60 + "px";

    editorFields.style.height = height - 60 + "px";
    for (let i = 0; i < fieldsContainers.length; i++) {
      if (fieldsContainers[i].className.indexOf("price") > -1 ||
          fieldsContainers[i].className.indexOf("span6") > -1 ||
          fieldsContainers[i].className.indexOf("autoHeight") > -1 ) {
        continue;
      }

      fieldsContainers[i].style.height = height - 60 + "px";
    }
  }

  getDOMElement() {
    return document.querySelectorAll(
                                '[data-cms-render="' + this.path[0] + '"]')[0];
  }

  open(data, flux) {
    window.editorLoaded = true;
    window.scrollTo(0, this.getDOMElement().offsetTop);

    let resizeButton = this.modal.el.getElementsByClassName("resizeModal")[0];
    let resizeTo = (resizeButton.innerHTML === "Bigger") ? "Smaller" : "Bigger";
    this.resizeElement(resizeTo);
    this.modal.show();

    if (editorMapping[this.type].loadForm) {
      (editorMapping[this.type].loadForm)({modal: this.modal,
                                         editor: this.editor,
                                         data,
                                         path: this.path,
                                         updateState: this.updateState.bind(this)});
    }
  }
}



// WEBPACK FOOTER //
// ./src/EditorModal.js